import { FC } from 'react'

import {
  AccountingDraftEntriesCountWidgetDocument,
  AccountingDraftEntriesCountWidgetQuery,
  FinanceJournalDraftEntryFilter,
  FinanceValueObjectsJournalDraftEntryStatusEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  FinanceWidget,
  SupportedCharts,
} from 'modules/finance/components/Widgets/common/FinanceWidget'
import { removeNullBetween } from 'modules/finance/components/Widgets/common/utils'
import { buildWidget } from 'modules/finance/components/Widgets/common/widgets'

interface QueryArgsType {
  companyId: number
  statuses: FinanceValueObjectsJournalDraftEntryStatusEnum[]
}

const prepareData = (data: AccountingDraftEntriesCountWidgetQuery) => {
  const count = data?.finance?.journalDraftEntriesConnection?.totalCount || 0

  return {
    countersChartDatas: [
      {
        label: i18n.t('finance.overview.accounting.title_v2'),
        value: count,
        formattedValue: i18n.formatNumber(count),
      },
    ],
  }
}

export const buildAccountingDraftEntriesCountWidget = ({
  widgetTitle,
  queryArgs,
  filters,
}: {
  widgetTitle?: string
  queryArgs: QueryArgsType
  filters: FinanceJournalDraftEntryFilter
}) => {
  const AccountingDraftEntriesCountWidget: FC<{
    data: ReturnType<typeof prepareData>
  }> = ({ data }) => {
    const { countersChartDatas } = data

    return (
      <FinanceWidget
        id="accountingDraftEntriesCountDashboard"
        type={SupportedCharts.COUNTERS}
        showChart={false}
        countersChartDatas={countersChartDatas.map((chartData) => ({
          ...chartData,
          label: widgetTitle || chartData.label,
        }))}
      />
    )
  }

  // This is to avoid problems with date filter and between provoked by the use of datatable filters
  const filteredFilters = removeNullBetween(filters)

  return buildWidget({
    id: 'accountingDraftEntriesCountWidget',
    component: AccountingDraftEntriesCountWidget,
    document: AccountingDraftEntriesCountWidgetDocument,
    prepareData: (data: AccountingDraftEntriesCountWidgetQuery) => prepareData(data),
    queryArgs: {
      ...queryArgs,
      filter: {
        ...filteredFilters,
      },
    },
  })
}
